<template>
  <div>
    <template v-if="!toggled">
      <router-link class="items-container__item item" :to="{ name: item.type === 'pack' ? 'product' : 'tenant', params: {id: item.id}}" v-if="routeName=='lastEdited' || routeName=='lastEditedGuests'">
        <div class="item__row item__title item__title--icon">
          <slot name="item-template-title" :item="item">
            <span>
              <i class="type-icon icon-product-black" v-if="item.type==='pack'"/>
              <i class="type-icon icon-user-black" v-if="item.type==='tenant'"/>
              <i class="type-icon icon-parking-clock-black" v-if="item.type==='guestParking'"/>
              {{ item.name }}
            </span>
            <!-- <span title="total">{{ item.type === 'guestParking' && item.total === 0 ? `&#8734;` : item.total ? item.total : '' }}</span> -->
            <span title="total" v-if="item.total">{{ item.total }}</span>
          </slot>
        </div>
        <div class="item__statusbar">
          <span class="filling" v-bind:style="{ width: calcStatusBarWidth(item.issued, item.total) + '%' }" v-if="item.total"></span>
          <span class="filling" v-bind:style="{ 'background-color': '#D8D8D8'}" v-else></span>
        </div>
        <div class="item__row item__subtitle">
          <slot name="item-template-subtitle" :item="item">
            <span>{{ item.address }}</span>
            <span>
              <span class="orange" title="issued">{{ item.issued }}</span>
            </span>
          </slot>
        </div>
      </router-link>

      <router-link class="items-container__item item" :to="{ name: routeName, params: {id: item.id}, query: { keyword: this.$route.query.keyword}}" v-else>
        <div class="item__row item__title item__title--icon">
          <slot name="item-template-title" :item="item">
            <span>{{ item.name }}</span>
            <!-- <span title="total">{{ item.type === 'guestParking' && item.total === 0 ? `&#8734;` : item.total ? item.total : '' }}</span> -->
            <span title="total" v-if="item.total">{{ item.total }}</span>
          </slot>
        </div>
        <div class="item__statusbar">
          <span class="filling" v-bind:style="{ width: calcStatusBarWidth(item.issued, item.total) + '%' }" v-if="item.total"></span>
          <span class="filling" v-bind:style="{ 'background-color': '#D8D8D8'}" v-else></span>
        </div>
        <div class="item__row item__subtitle">
          <slot name="item-template-subtitle" :item="item">
            <span>{{ item.address }}</span>
            <span>
              <span class="orange" title="issued">{{ item.issued }}</span>
            </span>
          </slot>
        </div>
      </router-link>
    </template>

    <template v-else>
      <router-link class="items-container__item item item_tenant" :to="{ name: routeName, params: {id: item.id}}">
        <div class="item__row item__title">
          <span>{{ item.name }}</span>
          <span><span class="orange" title="issued">{{ item.issued }}</span> <span class="disabled">/</span> {{ item.total }}</span>
        </div>
        <div class="item__statusbar"></div>
        <div class="item__row">
          <table class="tenant-products">
            <tr v-for="(product,index) in item.products" class="tenant-products__row" :key="index">
              <td class="tenant-products__name">
                <router-link class="link" :to="{ name: 'product', params: { id: product.id}}">
                  {{ product.name }}
                </router-link>
              </td>
              <td class="tenant-products__statusbar">
                <span class="item__statusbar">
                  <span class="filling" v-bind:style="{ width: calcStatusBarWidth(product.issued, product.total) + '%' }"></span>
                </span>
              </td>
              <td class="tenant-products__counters">
                <span>
                  <span class="orange">{{ product.issued }}</span>&nbsp;<span class="disabled">/</span>&nbsp;{{ product.total }}
                </span>
              </td>
            </tr>
          </table>
        </div>
      </router-link>
    </template>
  </div>
</template>

<script>
import { connectEcho } from 'src/utils.js';

export default {
  name: 'widgetItem',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => [],
    },
    routeName: {
      type: String,
      required: true,
    },
    toggled: {
      type: Boolean,
      required: true,
      default: false,
    },
    isWebsocketConnect: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {
    if (this.isWebsocketConnect === true && this.item.type === 'guestParking') {
      connectEcho().private(`product_${this.item.id}`)
        .listen('.change.guest.pack.count', (e) => {
          console.log(e);
        });
    }
  },
  destroyed() {
    if (this.isWebsocketConnect === true) {
      connectEcho().leave(`private-product_${this.item.id}`);
    }
  },
  methods: {
    calcStatusBarWidth(issued, total) {
      let width = 0;
      if (total === 0) {
        width = 0;
      } else {
        width = (issued / total) * 100;
      }
      return width;
    },
  }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/common/widgetItem.vue